<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit Category">
      <div class="row">
        <div class="col-md-6 form-group">
          Name
          <input
            class="form-control"
            type="text"
            v-model="name"
            @focus="nameEmpty = ''"
          />
          <div class="form-group" style="color: red" v-if="nameEmpty">
            {{ nameEmpty }}
          </div>
        </div>
        <div class="col-md-6 form-group">
          Image
          <b-form-file
            id="fileinput"
            class="form-control"
            type="file"
            @focus="selectedImageEmpty = ''"
            @change="imageUpload"
          ></b-form-file>
          <div class="form-group" style="color: red" v-if="selectedImageEmpty">
            {{ selectedImageEmpty }}
          </div>
        </div>
      </div>

      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="saveChanges()"
          >Save Changes</b-button
        >
      </div>
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      selectedImageEmpty: null,
      nameEmpty: null,
      name: "",
      id:"",
      selectedImage: "",
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    imageUpload(event) {
      this.selectedImage = event.target.files[0];
    },
    async loadData() {
      await axios
        .get(`${this.$store.getters.baseUrl}/category/edit/${this.$route.params.id}`, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        })
        .then((response) => {
          const {data:{category:{id='',name=''}={}}={}}=response;
          this.name = name;
          this.id = id;

        })
        .catch((error) => {
          console.log(error);
        });
    },
    async saveChanges() {
      if (this.name == "") {
        this.nameEmpty = "Category name is required";
        return;
      }
      if (this.selectedImage == "") {
        this.selectedImageEmpty = "Category image is required";
        return;
      }
      const formdata = new FormData();
      formdata.append("image", this.selectedImage);
      formdata.append("name", this.name);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/category/update/${this.id}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$swal("Success", "Category updated successfully", "success");
             this.$router.push({name: 'Tables Category'});
            this.name = "";
            //document.getElementById('fileinput__BV_file_outer_').lastChild.firstChild.textContent = ""
          }
        })
        .catch((error) => {
          if (error.response.data.status == "error") {
            this.$swal("Failed", "Error while adding category", "error");
          }
        });
    },
  },
};
</script>

